"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function AboutUsMenu(props) {
    var currentLang = props.lang;
    var t = props.tMegamenu;
    return (React.createElement("div", { className: "c-mm-grid-section", style: { gridTemplateColumns: "repeat(2, 1fr)" } },
        React.createElement("div", { className: "c-mm-column" },
            React.createElement("div", { className: "c-mm-header" },
                React.createElement("i", { className: "fal fa-building" }),
                React.createElement("div", null, t.ourCompany)),
            React.createElement("div", { className: "c-mm-list" },
                React.createElement("a", { href: "/" + currentLang + "/about-us", className: "c-mm-item" },
                    React.createElement("span", null, t.ourStory)),
                React.createElement("a", { href: "/" + currentLang + "/property-experts", className: "c-mm-item" },
                    React.createElement("span", null, t.executiveTeam)),
                React.createElement("a", { href: "/" + currentLang + "/about-us/in-the-press", className: "c-mm-item" },
                    React.createElement("span", null, t.inThePress)),
                React.createElement("a", { href: "/" + currentLang + "/communication/enquiry", className: "c-mm-item" },
                    React.createElement("span", null, t.contactUs)))),
        React.createElement("div", { className: "c-mm-column" },
            React.createElement("div", { className: "c-mm-header" },
                React.createElement("i", { className: "far fa-users" }),
                React.createElement("div", null, t.agents)),
            React.createElement("div", { className: "c-mm-list" },
                React.createElement("a", { href: "/" + currentLang + "/property-agent-team", className: "c-mm-item" },
                    React.createElement("span", null, t.findAnAgent)),
                React.createElement("a", { href: props.careerUrl, target: "_blank", className: "c-mm-item" },
                    React.createElement("span", null, t.joinAsAnAgent)),
                React.createElement("a", { href: "/" + currentLang + "/about-us/testimonials", className: "c-mm-item" },
                    React.createElement("span", null, t.testimonials))))));
}
exports.default = AboutUsMenu;
